import {
    Component,
    ChangeDetectionStrategy,
    Input,
    HostBinding,
    Output,
    TemplateRef,
    ContentChild,
    EventEmitter,
} from '@angular/core';

@Component({
    selector: 'bazis-list-hint',
    templateUrl: './list-hint.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisListHintComponent {
    @HostBinding('class') get hostStyle() {
        return {
            'bazis-list': true,
            'bazis-list_control-dd': true,
        };
    }

    @Input() list;

    @Input() loadingList: boolean = false;

    @Input() placeholderListKey: string;

    @Input() emptyListKey: string;

    @Input() loadingListKey: string;

    @Input() updatingListKey: string;

    @Output() selected = new EventEmitter();

    @ContentChild(TemplateRef) itemTpl: TemplateRef<any>;

    selectValue(value) {
        this.selected.emit(value);
    }
}
